import React from 'react';
import { Text, View } from 'react-native';
import { useParams } from 'react-router-dom';

import { CourseType, CourseV2 } from '../../api/models/Course';
import { CourseDetailsProps } from '../containers/CourseDetailsContainer';
import { MNOHSCourseDetails } from '../MNOHSCourseDetails';
import { MNOHSCourseGrid } from '../MNOHSCourseGrid';
import { MNOHSDashboardWrapper } from '../MNOHSDashboardWrapper';

/**
 * Course Details screen for student roles
 * @param param0
 */
export const CourseDetailsScreen: React.FC<CourseDetailsProps> = ({
  student,
  currentPage,
  courses,
  userPressedCourseDetails,
  isGettingCourseGroups,
  userClickedPaginationDot,
}) => {
  const { course: courseParam }: { course: CourseType } = useParams();

  const courseName = courseParam.split('_').join(' ');
  // only return those which don't have null courseName
  const courseList: CourseV2[] = courses.map(group => group.coursesForList.filter(course => course.courseName)).flat();

  return (
    <MNOHSDashboardWrapper headerTitle={'Course Details'} padded={true}>
      <MNOHSCourseDetails
        student={student}
        currentPage={currentPage}
        courseName={courseName}
        isGettingCourseGroups={isGettingCourseGroups}
        courseList={courseList}
        courseGroup={courses[0]}
        userClickedPaginationDot={userClickedPaginationDot}
      />

      <MNOHSCourseGrid userPressedCourseDetails={userPressedCourseDetails} />
    </MNOHSDashboardWrapper>
  );
};
